import * as React from "react";
import Svg, { Path } from "react-native-svg";
function RedErrorIcon(props) {
    return (React.createElement(Svg, { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement(Path, { d: "M1.667 7A5.335 5.335 0 017 1.667 5.335 5.335 0 0112.333 7 5.335 5.335 0 017 12.333 5.335 5.335 0 011.667 7z", fill: "#DE4043", stroke: "#DE4043" }),
        React.createElement(Path, { d: "M6.935 9.333a.519.519 0 100-1.037.519.519 0 000 1.037zM6.935 4.667a.52.52 0 00-.518.518V7.26a.52.52 0 00.518.519.52.52 0 00.519-.519V5.185a.52.52 0 00-.519-.518z", fill: "#FFEBEB" })));
}
export default RedErrorIcon;
